/* eslint-disable react/destructuring-assignment */
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { bool, string } from "prop-types";
import React, { useContext } from "react";
import { resizableRoute as resizableComponent } from "pages/_components/Resizable";

const ContactSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const {
        accountNumber = props.accountNumber,
        productType = props?.productType,
        cbu = props.cbu,
        name = props.name,
        localBank = props.localBank,
        recipientEmail = props.recipientEmail,
        recipientDocumentType = props.recipientDocumentType,
        recipientDocumentNumber = props.recipientDocumentNumber,
        recipientName = props.recipientName,
        isOwn = props.isOwn,
    } = data;
    const { isTicket, isDesktop } = props;

    if (isTicket) {
        return (
            <div className="ticket__body contact-summary-list">
                <div className="ticket-section three-columns">
                    <CustomData
                        titleText="transfer.frequentDestination.creditAccount"
                        titleTextType="I18N"
                        valueText={accountNumber}
                    />
                    <CustomData
                        titleText="accounts.create.accountType"
                        titleTextType="I18N"
                        valueText={`${productType.replace("ARS", "$")}`}
                    />

                    <CustomData
                        titleText="transfer.frequentDestination.isOwn"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={isOwn === "1" ? "global.yes" : "global.no"}
                    />
                    <CustomData titleText="transfer.frequentDestination.cbucvu" titleTextType="I18N" valueText={cbu} />
                    <CustomData
                        titleText="transfer.frequentDestination.document"
                        titleTextType="I18N"
                        valueText={`${recipientDocumentNumber}`}
                    />
                    <CustomData
                        titleText="transfer.frequentDestination.recipientName"
                        titleTextType="I18N"
                        valueText={recipientName}
                    />
                    <CustomData
                        titleText="transfer.frequentDestination.localBank"
                        titleTextType="I18N"
                        valueText={localBank}
                    />
                </div>
                <div className="ticket-section">
                    {!props.isModify && (
                        <>
                            <div className="ticket__divider inside-ticket__body">
                                <div className="ticket__notch ticket__notch--left"> </div>
                                <div className="ticket__notch ticket__notch--right"> </div>
                            </div>
                            <CustomData
                                titleText="transfer.frequentDestination.recipientEmail"
                                titleTextType="I18N"
                                valueText={recipientEmail}
                            />
                            <CustomData
                                titleText="forms.transferInternal.confirmation.reference"
                                titleTextType="I18N"
                                valueText={name}
                            />
                        </>
                    )}
                </div>
                {props.isTicket && <TransactionSign isDesktop={isDesktop} showMoreData />}
            </div>
        );
    }
    return (
        <GridTable className="form-summary">
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.frequentDestination.creditAccount"
                        titleTextType="I18N"
                        valueText={accountNumber}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="accounts.create.accountType"
                        titleTextType="I18N"
                        valueText={`${productType.replace("ARS", "$")}`}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.frequentDestination.isOwn"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={isOwn === "1" ? "global.yes" : "global.no"}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="transfer.frequentDestination.cbucvu" titleTextType="I18N" valueText={cbu} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.frequentDestination.document"
                        titleTextType="I18N"
                        valueText={`${recipientDocumentType} ${recipientDocumentNumber}`}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.frequentDestination.recipientName"
                        titleTextType="I18N"
                        valueText={recipientName}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="transfer.frequentDestination.localBank"
                        titleTextType="I18N"
                        valueText={localBank}
                    />
                </GridTable.Data>
                {!props.isModify && (
                    <>
                        <GridTable.Data>
                            <CustomData
                                titleText="transfer.frequentDestination.recipientEmail"
                                titleTextType="I18N"
                                valueText={recipientEmail}
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="forms.transferInternal.confirmation.reference"
                                titleTextType="I18N"
                                valueText={name}
                            />
                        </GridTable.Data>
                    </>
                )}
            </GridTable.Container>
        </GridTable>
    );
};

ContactSummaryBody.propTypes = {
    name: string,
    productType: string,
    localBank: string,
    accountNumber: string,
    recipientName: string,
    recipientDocumentType: string,
    recipientDocumentNumber: string,
    recipientEmail: string,
    cbu: string,
    isOwn: string,
    isModify: bool,
    isTicket: bool,
    isDesktop: bool,
};

ContactSummaryBody.defaultProps = {
    name: "",
    productType: "",
    localBank: "",
    accountNumber: "",
    recipientName: "",
    recipientDocumentType: "",
    recipientDocumentNumber: "",
    recipientEmail: "",
    cbu: "",
    isOwn: "",
    isModify: false,
    isTicket: false,
    isDesktop: false,
};

export default resizableComponent(ContactSummaryBody);
